export default __webpack_public_path__ + "static/media/highscores-group.36621832.png";